module.exports = __webpack_public_path__ + "assets/images/couch-03.ef94143c505a32c2edf15c544f2286cd.svg";